// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__23HnF","question":"styles_question__3Ssaj","description":"styles_description__2U3lh"};